// 旧协议
function kkhybrid_nativeto_h5_reload (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "nativetoh5reload",
    },
    param: {
      isReload:opt.isReload
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

// 新协议
function kkmhhybrid_nativeto_h5_reload (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "nativeto_h5_reload",
    },
    param: {
      isReload:opt.isReload
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

/**
 * Native 返回H5 是否强制刷新<br>
 * kkhybrid://nativetoh5reload，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=17698067}<br>
 * @param {Object} opt 参数对象
 * @param {Boolean} opt.isReload 是否刷新
 * @param {Function} opt.callback 回调函数
 */
function nativeto_h5_reload (opt = {}, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion)
  if (allow) {
      kkmhhybrid_nativeto_h5_reload(opt);
  } else {
      kkhybrid_nativeto_h5_reload(opt);
  }
}

export default nativeto_h5_reload;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/nativeto_h5_reload/index.js